import { ResponsiveLine } from '@nivo/line'
import React from "react";


export const BiometricsChart = ({ data, xFormat, AxisBottomLegend, axisBottomFormat, AxisLeftLegend, changeData }) => {
    return (
        <ResponsiveLine
            data={data}
            margin={{ top: 50, right: 110, bottom: 110, left: 60 }}
            xScale={{ format: "%d/%m/%Y %H:%M:%S", type: "time", useUTC: false }}
            xFormat={xFormat}
            yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: false, reverse: false }}
            yFormat=" >-.2f"
            axisTop={null}
            axisRight={null}
            axisBottom={{
                orient: 'bottom',
                tickSize: 0,
                tickPadding: 5,
                tickRotation: 0,
                legend: 'transportation',
                legendOffset: 80,
                legendPosition: 'left',
                tickRotation: 30,
                format: axisBottomFormat,
                legend: AxisBottomLegend,
            }}
            axisLeft={{
                orient: 'left',
                tickSize: 15,
                tickPadding: 5,
                tickRotation: 0,
                legend: AxisLeftLegend,
                legendOffset: -50,
                legendPosition: 'middle'
            }}
            pointSize={10}
            pointColor={{ theme: 'background' }}
            pointBorderWidth={2}
            pointBorderColor={{ from: 'serieColor' }}
            pointLabelYOffset={-12}
            enablePointLabel={true}
            enablePoints={false}
            useMesh={true}
            enablePointLabel={true}
            legends={[
                {
                    onClick: (e) => {
                        if (changeData) { changeData(e) }
                    },
                    anchor: 'bottom-right',
                    direction: 'column',
                    justify: false,
                    translateX: 100,
                    translateY: 0,
                    itemsSpacing: 0,
                    itemDirection: 'left-to-right',
                    itemWidth: 125,
                    itemHeight: 30,
                    itemOpacity: 0.75,
                    symbolSize: 12,
                    symbolShape: 'circle',
                    symbolBorderColor: 'rgba(0, 0, 0, .5)',
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemBackground: 'rgba(0, 0, 0, .03)',
                                itemOpacity: 1
                            }
                        }
                    ]
                }

            ]}
        />
    )
}